/**
 * Cliente API para comunicación con el backend
 */

import axios from 'axios';
import toast from 'react-hot-toast';

const API_BASE_URL = import.meta.env.VITE_BACKEND_URL || 'http://localhost:3000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_data');

      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
        toast.error('Sesión expirada. Por favor, inicie sesión nuevamente.');
      }
    } else if (error.response?.status >= 500) {
      toast.error('Error del servidor. Por favor, intente nuevamente.');
    } else if (error.code === 'ECONNREFUSED' || error.code === 'NETWORK_ERROR') {
      toast.error('Error de conexión. Verifique su conexión a internet.');
    }

    return Promise.reject(error);
  }
);

export const authService = {
  login: (nit) => api.post('/auth/login', { nit }),
  verify: (nit, code) => api.post('/auth/verify', { nit, code }),
  register: (nit, correo) => api.post('/auth/register', { nit, correo }),
  getMe: () => api.get('/auth/me'),
  refresh: () => api.post('/auth/refresh'),
};

export const invoicesService = {
  getPending: () => api.get('/invoices'),
  getSummary: () => api.get('/invoices/summary'),
  calculateTotal: (facturas) => api.post('/invoices/calculate', { facturas }),
};

export const paymentsService = {
  create: (data) => api.post('/payments/create', data),
  getReference: (id) => api.get(`/payments/reference/${id}`),
  getHistory: (page = 1, limit = 10) =>
    api.get(`/payments/history?page=${page}&limit=${limit}`),
};

export const checkApiHealth = async () => {
  try {
    const response = await api.get('/health');
    return response.data;
  } catch (error) {
    console.error('Error verificando salud de API:', error);
    return null;
  }
};

export default api;